import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL e Anon Key são obrigatórios');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Tipos
export interface Noticia {
  id: string;
  titulo: string;
  slug: string;
  resumo: string;
  conteudo: string;
  imagem_url: string;
  autor?: string;
  data_publicacao: string;
  ativo: boolean;
  created_at: string;
  updated_at: string;
}

export interface NoticiaExterna {
  id: string;
  titulo: string;
  resumo: string;
  conteudo_parcial: string;
  url_original: string;
  imagem_url: string | null;
  data_publicacao: string;
  fonte: string;
  ativo: boolean;
  created_at: string;
  updated_at: string;
}

export interface Servico {
  id: string;
  titulo: string;
  slug: string;
  descricao: string;
  icone?: string;
  imagem_url?: string;
  ordem: number;
  ativo: boolean;
  created_at: string;
  updated_at: string;
}

export interface ConfiguracaoSite {
  id: string;
  chave: string;
  valor: string;
  tipo: string;
  descricao: string;
  updated_at: string;
}
